const cadastro_constante_aluno_novo = {
  path: "/cadastro-constante-aluno-novo",
  redirect: "/cadastro-constante-aluno-novo",
  meta: {
    breadCrumb: "Planejamento Matricula - Tabelas de Apoio ao Planejamento",
  },
  children: [
    {
      path: "/cadastro-constante-aluno-novo",
      name: "cadastro-constante-aluno-novo",
      meta: {
        allowedPermissions: [
          "valor_absoluto_listar",
          "valor_absoluto_buscar",
          "valor_absoluto_excluir",
        ],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroConstanteAlunoNovo/CadastroConstanteAlunoHome.vue"
        ),
    },
    {
      path: "/cadastro-de-constante-aluno-novo",
      name: "cadastro-de-constante-aluno-novo",
      meta: {
        allowedPermissions: ["valor_absoluto_criar"],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroConstanteAlunoNovo/CadastroConstanteAlunoCreate.vue"
        ),
    },
    {
      path: "/cadastro-de-constante-aluno-editar/:id",
      name: "cadastro-de-constante-aluno-editar",
      meta: {
        allowedPermissions: ["valor_absoluto_atualizar"],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroConstanteAlunoNovo/CadastroConstanteAlunoUpdate.vue"
        ),
    },
  ],
};

export { cadastro_constante_aluno_novo };
